"use client"
import { Box, Container, Typography } from "@mui/material"
import { School, Work, ShoppingBag } from "@mui/icons-material"
import { useTranslation } from "react-i18next"
import image from "../../assets/images/AboutProcess.png"
import Animator from "../Aminator/Animator"

const stepIcons = [
    { icon: <ShoppingBag className="w-6 h-6" />, iconBg: "bg-[#FCEDEE]", iconColor: "text-[#A62D69]" },
    { icon: <School className="w-6 h-6" />, iconBg: "bg-blue-100", iconColor: "text-blue-600" },
    { icon: <Work className="w-6 h-6" />, iconBg: "bg-green-100", iconColor: "text-green-600" },
]

export default function AboutProcess() {
    const { t } = useTranslation();
    const processSteps = t("about.process.steps", { returnObjects: true }).map((step, i) => ({
        ...step,
        ...stepIcons[i],
    }))

    return (
        <Box className="py-5 md:py-[78px] bg-white relative px-2 md:px-20 overflow-hidden">
            
            <Container maxWidth="xl">
                <Box className="grid grid-cols-1 lg:grid-cols-2 gap-16 md:gap-16 items-start">
                    {/* Left Column - Image */}
                    <Animator variant="slide" direction="right" timeout={800} delay={300}>
                        
                    <Box className="relative">
                        <Box className="rounded-2xl overflow-hidden shadow-lg">
                            <img
                                src={image}
                                alt="Modern workspace with laptop and desk setup"
                                className="w-full h-[300] md:h-[500px] object-cover"
                                style={{
                                    background: "linear-gradient(135deg, #e2e8f0 0%, #cbd5e1 100%)",
                                }}
                                />
                           
                        </Box>
                    </Box>
                    </Animator>
                    {/* Right Column - Process Steps */}
                    <Animator variant="slide" direction="left" timeout={800} delay={300}>
                    <Box className="space-y-8">
                        {/* Section Header */}
                        <Box className="mb-11">
                            <Typography
                                variant="h3"
                                sx={{
                                    fontSize: { xs: "24px", md: "30px" },
                                    lineHeight: 1.2,
                                    fontWeight: 600,
                                    fontFamily: "'Montserrat', sans-serif",
                                    marginBottom: "5px",
                                    color: "#000",
                                }}
                            >
                                {t("about.process.title")}
                            </Typography>
                            <Typography
                                variant="body1"
                                className="text-[#00000080] leading-relaxed"
                                sx={{
                                    fontSize: { xs: "16px", md: "16px" },
                                    lineHeight: 1.6,
                                    fontFamily: "'Montserrat', sans-serif",
                                }}
                            >
                                    {t("about.process.subtitle")}
                            </Typography>
                        </Box>

                        {/* Process Steps */}
                        <Animator variant="slide" direction="left" timeout={800} delay={500}>
                        <Box className="space-y-7">
                            {processSteps.map((step, index) => (
                                <Box key={index} className="flex items-start space-x-6">
                                    {/* Icon */}
                                    <Box className={`${step.iconBg} ${step.iconColor} p-3 rounded-lg flex-shrink-0`}>{step.icon}</Box>

                                    {/* Content */}
                                    <Box className="flex-1">
                                        <Typography
                                            variant="h6"
                                            className="text-black font-bold mb-2"
                                            sx={{
                                                fontSize: { xs: "16px", md: "16px" }, 
                                                fontFamily: "'Montserrat', sans-serif",
                                            }}
                                        >
                                            {step.title}
                                        </Typography>
                                        <Typography
                                            variant="body2"
                                            className="text-[#00000080] "
                                            sx={{
                                                fontSize: { xs: "16px", md: "16px" },
                                                
                                                fontFamily: "'Montserrat', sans-serif",
                                            }}
                                        >
                                            {step.description}
                                        </Typography>
                                    </Box>
                                </Box>
                            ))}
                        </Box>
                        </Animator>
                    </Box>
                    </Animator>
                </Box>
            </Container>
        </Box>
    )
}
